<template>
    <div>标题:成色配置</div>
    <div>
        搜索栏:条件1:选择平台;条件2:选择瑕疵项;条件3:选择判定配置;
        <span>要求:模糊搜索</span>
        按钮: 查询;重置
    </div>
    <div>
        表格:表头:平台;瑕疵项;判定配置;操作
        <span>操作:修改,删除</span>
    </div>
</template>

<script setup>
    // import { defineExpose } from "vue";
    /* ################################## */
    /*                页面初始化               */
    /* ################################## */
    const nowtabInit = () => {};
    // 需要暴露给父组件
    defineExpose({
        nowtabInit,
    });
</script>
